import React, { FC, useRef } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Close } from "@app/components/common/icons";
import { AMGContactForm } from "@app/components/amg-contact-form/AMGContactForm";
import { Dialog } from "@app/constants/ui";
import { ModalState } from "@app/enums/modal";
import { useOutsideClick, useModal } from "@app/hooks";

export const AMGContact: FC = () => {
  const { t } = useTranslation("amg-contact-modal");
  const { onChangeModalState } = useModal();
  const ref = useRef<HTMLDivElement>(null);

  const onClose = () => {
    onChangeModalState(ModalState.IDLE);
  };

  useOutsideClick(ref, onClose);

  return (
    <dialog id={Dialog.AMG_CONTACT} className="modal modal-open z-[1000]">
      <div
        className={classNames(
          "modal-box relative max-h-screen w-screen rounded-none bg-dark px-5 pb-10 pt-15 text-primary-content",
          "scrollbar-thumb-rounded overflow-auto scrollbar scrollbar-thin scrollbar-track-transparent scrollbar-thumb-base-400",
          "md:max-h-[calc(100vh-2em)] md:rounded-lg md:px-10 md:pb-15",
          "xl:w-full xl:max-w-[600px] xl:px-20",
        )}
        ref={ref}
      >
        <h3 className={classNames("mb-10 text-center text-large")}>
          {t("title")}
        </h3>
        <p className="mb-5 text-start text-regular text-base-400">
          {t("subtitle")}
        </p>
        <AMGContactForm />
        <p className="mt-5 text-start text-extra-small italic text-base-400">
          {t("disclaimer")}
        </p>
        <Close
          className={classNames(
            "absolute right-5 top-5 h-5 w-5 cursor-pointer duration-300",
            "lg:right-6 lg:top-6 lg:h-6 lg:w-6",
            "hover:opacity-75",
          )}
          onClick={onClose}
        />
      </div>
    </dialog>
  );
};
